<template>
  
  <div class="home" v-if="ready">
    <!-- contenuto home -->
  </div>
  
</template>

<script>
// @ is an alias to /src
// import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
  },
  
  props: {

  },
  
  data: function() {
    return {
      ready: false,
      showheader: true,
      debug:false
    };
  },
  
  watch: { 
    '$route': async function() {
      console.log("watch routeChanged");
      console.log(this.$route.path);
      console.log(this.$route.params);
    },
  },
  
  computed: {

  },
  
  created: async function() {
    console.log('home created');
  },
  
  mounted: async function() {
    this.ready=true;
  },
  
  methods: {
    
  },
}

</script>

<style scoped>
</style>

